import { useTranslations } from "adapters/i18n";
import { useMemo } from "react";
import { LotGoalStatusFilter } from "../utils/lotGoal.utils";

export function useFilterOptions() {
  const { t } = useTranslations();

  const statusOptions = useMemo(
    () => [
      {
        value: LotGoalStatusFilter.All,
        label: t("common:all-male").toUpperCase(),
      },
      {
        value: LotGoalStatusFilter.Active,
        label: t("common:status.activated-plural").toUpperCase(),
      },
      {
        value: LotGoalStatusFilter.Inactive,
        label: t("common:status.disabled-plural").toUpperCase(),
      },
    ],
    [t]
  );

  return { statusOptions };
}
